<template>
  <div class="" v-if="companyData != null">
    <div class="">
      <div class="registration-head text-center" :style="styleHeader">
        <div class="sml-container">
          <div class="rg-head">
            <h1>キャリア登録フォーム</h1>
          </div>
        </div>
      </div>
      <div class="sml-container">
        <div class="rgst-sec">
          <div class="career-rgst">
            <h2>キャリア登録先企業</h2>
            <div class="fast-retail-box">
              <div
                :class="
                  companyData.logo_alignment
                    ? 'fast-retail-logo logo-vertical'
                    : 'fast-retail-logo logo-horizontal'
                "
              >
                <img
                  v-if="companyData.companyLogo !== null"
                  :src="companyData.companyLogo"
                  alt="logo"
                  class="img-fluid"
                />
                <i class="fas fa-building" v-else></i>
              </div>
              <h3>{{ companyData.companyName }}</h3>
            </div>
          </div>
          <!-- ends career-rgst -->
          <div class="tg-company" v-html="companyData.companyDescription"></div>

          <div class="rgst-dtl-sec">
            <!-- registration form component -->
            <BRegistration :endpointKey="'ServerValidation'" @redirectToPreviewPage="redirectToPreview"/>
          </div>
        </div>
        <!-- ends rgst-sec -->
      </div>
    </div>
    <!-- ends main-area -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BRegistration from "./BRegistration.vue";
export default {
  name: "Registration",
  components: { BRegistration },
  data() {
    return {
      check: true
    }
  },
  computed: {
    ...mapGetters({companyData: "getCompanyData"}),
    styleHeader() {
      return this.companyData.brand_primary_color
        ? { background: this.companyData.brand_primary_color }
        : { background: "#000000" };
    },
    styleButton() {
      return this.companyData.brand_secondary_color
        ? {
            background: this.companyData.brand_secondary_color,
            "border-color": this.companyData.brand_secondary_color,
          }
        : {
            background: "#000000",
            "border-color": "#000000",
          };
    },
  },
  methods: {
    ...mapActions({
      setData: "setData",
      checkCompany: "checkCompany",
    }),
    redirectToPreview(){
      this.$router.push({
        name: "preview",
        params: { slug: this.$route.params.slug },
      });
    },
    scrollToTop() {
      const element = document.getElementsByClassName("main-wrapper")[0];
      if (element) {
        element.scrollIntoView();
        // console.log(parent.offsetTop - (parent.offsetHeight * 2));
        // console.log(parent.offsetTop);
        // console.log(document.getElementsByClassName('form-detail')[0]);
        // document.getElementsByClassName('form-detail')[0].scrollTop =
        // parent.offsetTop - (parent.offsetHeight * 2);
      }
    },
  },
  async mounted() {
    this.scrollToTop();
    const check = await this.checkCompany(this.$route.params.slug);
    if (!check) this.$router.push({ name: "Maintenance" });
  },
};
</script>

<style scoped>
#currently_enrolled {
  height: 15px;
  width: 15px;
}
.btn-cstm.btn-cv-submit {
  width: 47%;
}

.btn-cstm.btn-cv-delete {
  background-color: #787878;
  font-weight: 500;
  width: 49%;
}

textarea::placeholder {
  font-size: 16px;
}

textarea {
  display: flex;
  align-items: center;
}

.font-15 {
  font-size: 15px;
}

.flex-basis-100 {
  flex-basis: 100%;
}

@media (max-width: 767px) {
  .btn-cstm.btn-cv-submit {
    width: 100%;
  }

  .btn-cstm.btn-cv-delete {
    width: 100%;
    margin: 0px !important;
  }
}

@media only screen and (max-width: 992px) {
  .enrolled-date {
    flex-wrap: wrap;
  }
  .enrolled-date span {
    flex-basis: 100%;
    justify-content: center;
  }
}

.enrolled-date select {
  margin-right: 5px;
}

.enrolled-date span {
  margin-right: 20px;
  display: inline-flex;
  align-items: center;
  font-size: 25px;
  font-weight: 500;
}

.enrolled-date label {
  margin-right: 20px;
  display: inline-flex;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  color: #494949;
}

.disabled {
  background-image: none !important;
}

.mw-370 {
  max-width: 370px;
}

.is-valid {
  background-image: none;
}

.is-invalid {
  background-image: none;
}
.v-center {
  display: flex;
  align-items: center;
}
.justify-content-evenly {
  justify-content: space-evenly;
}
</style>
